import React, { useState, useEffect } from "react";
import {
  DialogContent,
  Card,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  CardContent,
} from "@material-ui/core";
import Colors from "shared/color";
import CustomInput from "components/custom/CustomInput";
import { toastSuccess, toastWarning } from "shared/utils";
import { createRefundEntry, getUserBankAccounts } from "shared/api";
import MNativeSelect from "components/ui/MNativeSelect";
import Spin from "components/ui/Spin";
import { Formik } from "formik";
import * as Yup from "yup";

const TCell = (props) => {
  return (
    <TableCell
      style={{
        border: "none",
        fontSize: "0.8125rem",
        padding: " 3px",
        ...props.style,
      }}
    >
      {props.children}
    </TableCell>
  );
};



export const RefundDialog = ({ handleClose, data }) => {
  const Schema = Yup.object().shape({
    refund_amount: Yup.string().required("Amount field is required!"),
    refund_amount: Yup.number().max(data["extra_payment_amount"]),
  });
  const [bankAccounts, setBankAccounts] = useState({});
  const [userBankReferenceNumber, setUserBankReferenceNumber] = useState("")

  useEffect(() => {
    getUserBankAccounts(data["user_reference_number"])
      .then((res) => {
        if (
          res.success &&
          res.data &&
          res.data["bank_account"] &&
          res.data["bank_account"].length
        ) {
          let bankDetails = {};
          let bankReferenceMapping = {}
          res.data["bank_account"].forEach((bank) => {
            bankDetails[bank["user_bank_account_id"]] = `${bank["bank_account_no"]} / ${bank["bank_name"]} / ${bank["bank_branch_ifsc"]}`;
            bankReferenceMapping[bank["user_bank_account_id"]] = {
              user_bank_reference_number: bank.user_bank_reference_number,
              user_bank_account_id: bank.user_bank_account_id
            };
          });

          setBankAccounts(bankDetails);
          setUserBankReferenceNumber(bankReferenceMapping);

        }
      })
      .catch((error) => {});
      // eslint-disable-next-line
  }, []);

  return (
    <Formik
      initialValues={{
        refund_mode_requested: "ORIGINAL_MODE_OF_PAYMENT",
        bank_details_id: "",
        refund_amount: data["extra_payment_amount"],
      }}
      validationSchema={Schema}
      onSubmit={async (values, { setSubmitting }) => {
        let reqData = {};
        reqData["refund_mode_requested"] = values["refund_mode_requested"];
        reqData["refunded_amount"] = values["refund_amount"];
        if (values["refund_mode_requested"] === "NEFT") {
          reqData["bank_details_id"] = values["bank_details_id"];
          reqData["user_bank_reference_number"] = values["user_bank_reference_number"];;
        }

        let res = await createRefundEntry(
          data["payment_reference_number"],
          reqData
        );
        if (res.success) {
          toastSuccess(res.message);
          handleClose(true);
        } else {
          toastWarning(res.message);
        }
        setSubmitting(false);
      }}
    >
      {({
        isValid,
        isSubmitting,
        handleSubmit,
        values,
        touched,
        handleChange,
        handleBlur,
        setFieldValue,
        ...allprops
      }) => {
        return (
          <Spin spinning={isSubmitting}>
            <form
              // className={classes.form}
              noValidate
              method="POST"
              onSubmit={handleSubmit}
            >
              <DialogContent
                dividers={false}
                style={{
                  backgroundColor: Colors["lighterPurple"],
                  fontSize: "0.8125rem",
                  // minWidth: "40vw",
                }}
              >
                <div className="flex-spacing" style={{ margin: "1rem 0px" }}>
                  <Card>
                    <CardContent>
                      <TableContainer>
                        <Table size="small" aria-label="simple table">
                          <TableBody>
                            <TCell style={{ width: "30%" }}>
                              Refund Model Requested
                            </TCell>
                            <TCell>
                              <MNativeSelect
                                onChange={handleChange}
                                style={{ width: "100%" }}
                                name="refund_mode_requested"
                                value={values.refund_mode_requested}
                                options={{
                                  ORIGINAL_MODE_OF_PAYMENT:
                                    "ORIGINAL_MODE_OF_PAYMENT",
                                  NEFT: "NEFT",
                                }}
                              />
                            </TCell>
                          </TableBody>
                          {values.refund_mode_requested === "NEFT" ? (
                            <TableBody>
                              <TCell style={{ width: "30%" }}>
                                Bank Details
                              </TCell>
                              <TCell>
                                <MNativeSelect
                                  onChange={(e) => {
                                    const selectedBankId = e.target.value;
                                    if (userBankReferenceNumber[selectedBankId]) {
                                      const selectedBank = userBankReferenceNumber[selectedBankId];
                                      setFieldValue("bank_details_id", selectedBank.user_bank_account_id);
                                      setFieldValue("user_bank_reference_number", selectedBank.user_bank_reference_number);
                                    }
                                  }}
                                  nulloption="Select"
                                  style={{ width: "100%" }}
                                  name="bank_details_id"
                                  value={values.bank_details_id}
                                  options={bankAccounts}
                                />
                              </TCell>
                            </TableBody>
                          ) : null}
                          <TableBody>
                            <TCell>Refund Amount</TCell>
                            <TCell>
                              <CustomInput
                                style={{
                                  width: "100%",
                                }}
                                type="number"
                                textFiledStyle={{ width: "100%" }}
                                name="refund_amount"
                                value={values.refund_amount}
                                onChange={handleChange}
                                placeholder="Refund Amount"
                              />
                            </TCell>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </CardContent>
                  </Card>
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  //   onClick={verifyPaymentHandler}
                  color="primary"
                  variant="contained"
                  className="shadow-none common_kissht_btn"
                  type="submit"
                  disabled={isSubmitting || !isValid}
                >
                  Submit
                </Button>
                <Button
                  onClick={handleClose}
                  variant="contained"
                  className="shadow-none common_kissht_btn"
                  disabled={isSubmitting || !isValid}
                >
                  Close
                </Button>
              </DialogActions>
            </form>
          </Spin>
        );
      }}
    </Formik>
  );
};
